import * as React from 'react'

function ImageNomination(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={221}
      height={206}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M44.35 42.862L9.237 24.742l34.35 26.852S2.507 57.108-.001 18.634c.01-.008 41.29-9.928 44.35 24.228zM175.035 98.457l10.117-36.026-19.491 37.545s-16.288-35.434 23.57-47.357c0-.009 20.985 34.507-14.196 45.838zM175.469 173.318l-30.119 24.785 38.816-21.297s-7.861 37.661-48.109 27.383c0 0 3.402-39.273 39.412-30.871zM98.644 69.328l.048-37.12-8.713 40.707s-25.334-30.564 9.994-51.116c0 0 29.628 28.616-1.329 47.53z"
        fill="#F4BA27"
      />
      <path
        d="M42.847 0c5.457 46.14 27.717 90.78 62.827 124.065 24.216 22.96 54.493 40.453 87.351 51.21A248.793 248.793 0 00221 182.663v-13.552a232.661 232.661 0 01-19.593-5.14 233.208 233.208 0 01-24.667-9.205c-22.605-9.937-43.34-23.418-60.737-39.915C83.453 84.001 62.699 42.736 57.319 0H42.847z"
        fill="#1978B2"
      />
      <path
        d="M111.252 0c10.339 54.84 32.712 107.673 65.567 154.461.201.281.393.563.594.844 5.504 7.797 10.722 14.247 15.662 19.624 10.578 11.475 19.883 18.004 27.925 22.017v-15.629c-7.362-4.848-13.805-11.034-19.558-17.669-4.356-5.043-8.319-10.349-11.986-15.532C157.778 103.247 136.094 52.604 125.841 0h-14.589z"
        fill="#219321"
      />
    </svg>
  )
}

export default ImageNomination
